import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tca-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnInit {
  modelValue: boolean;

  @Output() modelChange: EventEmitter<boolean> = new EventEmitter();

  @Input() get model(): boolean {
    return this.modelValue;
  }

  set model(value: boolean) {
    this.modelValue = value;
    this.modelChange.emit(this.modelValue);
  }

  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    this.model = !this.model;
  }
}
